import { shallowRef } from "vue";
import { defineStore } from "pinia";

const DEFAULT_LOCALE = "en_US";

/** Shared locale state for the independently mounted dashboard, header and footer apps. */
export const useLocaleStore = defineStore("locale", () => {
  const locale = shallowRef(DEFAULT_LOCALE);
  const supportedLocales = shallowRef<readonly string[]>([DEFAULT_LOCALE]);

  function initialize(initialLocale: string, availableLocales: readonly string[]): void {
    const uniqueLocales = [...new Set(availableLocales.filter(Boolean))];
    supportedLocales.value = uniqueLocales.length > 0 ? uniqueLocales : [DEFAULT_LOCALE];
    locale.value = supportedLocales.value.includes(initialLocale)
      ? initialLocale
      : supportedLocales.value[0];
  }

  function setLocale(value: string): void {
    if (supportedLocales.value.includes(value)) {
      locale.value = value;
    }
  }

  return { locale, supportedLocales, initialize, setLocale };
});
